import { connect } from 'react-redux'
import {
  selectIsLeftSidebarCollapsed,
  selectIsInboxBootstrapped,
} from 'selectors/app'
import { selectHasCurrentTicketSearchErrored } from 'selectors/search'

import { selectAgentHasMailboxAccess } from 'selectors/mailboxes_base'
import { doHideLaunchBar } from 'actions/app'
import { selectShowInboxesEmptyPage } from 'selectors/trial_setup'
import { selectPrefersShowTopNav } from 'selectors/app/selectAccountPreferences'
import { selectIsAccountBootstrapped } from 'selectors/app/selectAccount'
import { selectCurrentPayload } from 'selectors/location'
import { selectFlag } from 'ducks/flags'
import { HIDE_WEBINAR_ANNOUNCEMENT } from 'ducks/flags/flagNames'
import Layout from './view'

const select = state => {
  return {
    hasMailboxAccess: selectAgentHasMailboxAccess(state),
    hasSearchErrored: selectHasCurrentTicketSearchErrored(state),
    isLeftSidebarCollapsed: selectIsLeftSidebarCollapsed(state),
    showEmptyInboxPage: selectShowInboxesEmptyPage(state),
    isInboxBootstrapped: selectIsInboxBootstrapped(state),
    showTopNav: selectPrefersShowTopNav(state),
    isAccountBootstrapped: selectIsAccountBootstrapped(state),
    payload: selectCurrentPayload(state),
    shouldHideWebinarAnnouncement: selectFlag(state)(HIDE_WEBINAR_ANNOUNCEMENT),
  }
}

const perform = {
  doHideLaunchBar,
}

export default connect(select, perform)(Layout)
